<template>
  <div
    id="merge_print_order_invoices_modal"
    class="modal fade"
  >
    <div
      id="merge-print-area"
      class="modal-dialog modal-full"
      style="max-width: 850px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="rtl-float-left">
            <v-btn
              id="merge-print-button"
              @click="printInvoice"
              style="height:auto"
              outline
              color="primary"
            >{{ $t('printLogs.printButton') }}</v-btn>
          </div>
          <button
            id="merge-close-button"
            type="button"
            class="close"
            @click="closeModal('merge_print_order_invoices_modal')"
          >
            &times;
          </button>
        </div>

        <div class="modal-body">
          <order-invoice-document
            :invoiceData="printData"
            :companyData="companyData"
            :exRate="exRate"
          />
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderInvoiceDocument from './OrderInvoiceDocument.vue'

export default {
  components: {
    OrderInvoiceDocument
  },

  props: {
    printData: { default: () => ({ customer: {}, orders: [], second_orders: [] }) },
    companyData: { default: () => ({}) },
    exRate: { default: 1 },
    closeModal: { type: Function, required: true }
  },

  methods: {
    printInvoice() {
      $('#merge-close-button').hide()
      $('#merge-print-button').hide()

      $('#merge-print-area').printMe({ path: this.$_print_stylesheet_paths() })

      $('#merge-close-button').show()
      $('#merge-print-button').show()
    }
  }
}
</script>

<style scoped>
.modal {
  text-align: center;
  padding: 0 !important;
  overflow-x: auto;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/orderInvoice/MergePrintOrderInvoices.vue